<template>
	<div class="comp-body-wrapper">
		<div v-if="showLoader" class="loader-div">
			<div class="loader-image-circle"></div>
		</div>
		<Header></Header>
		<router-view></router-view>
		<note-pop-up v-if="showNotePopUp" />
	</div>
</template>

<script>

    const Header = () => import("./layouts/Header");
    import NotePopUp from "./dashboard/forecast/allocations/NotePopUp";

    export default {
        name: "Home",
        components: {
            NotePopUp,
            Header
        },
        computed: {
            showNotePopUp: function () {
                return this.$store.state.forecast.showNotePopUp;
            },
            showLoader: function () {
                return this.$store.state.forecast.globalLoader;
            }
        },
        beforeMount() {
            this.fetchApi();
            /*pdf path*/
            this.fetchPDFFilePath();
        },
        methods: {
            /**
             * Fetch data if already fetch
             */
            fetchApi: function () {
                let route = this.$route;
                if (!route.query || !route.query.redirect) {
                    //fetch the current Podio user
                    this.$store.dispatch("fetchPodioUser")
                        .then(
                            // response => {
                            // this.redirectToPage(response);
                            // }
                        );
                } else {
                    this.$router.replace({query: {}});
                }
            },
            // redirectToPage: function (data) {
            // if (data.canAccessQForecastForecasting) {
            //     this.$router.push({name: 'forecast'});
            // } else if (!data.canAccessQForecastForecasting && data.canAccessQForecastReporting) {
            //     this.$router.push({name: 'reports'});
            // } else {
            //     this.$router.push({name: 'qtime'});
            // }
            // }

            /*pdf path*/
            fetchPDFFilePath: function () {
                    //fetch pdf file path
                   
                    this.$store.dispatch("fetchPdfFilePath")
                        .then(
                            // response => {
                            // this.redirectToPage(response);
                            // }
                        );
            },
        },
        mounted(){
            // checking safari browser 
            var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
            
            if(isSafari){
                document.body.classList.add('safari-brow');
            }
            
             /* Browser == IE */
            if((navigator.userAgent.indexOf('MSIE') != -1) || (!!document.documentMode == true)){
                document.body.classList.add('ie-brow');
            }
        }
    }
</script>

<style scoped>
	.comp-body-wrapper {
		height: 100vh !important;
        overflow: auto;
	}

	.loader-div {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(245, 245, 245, 0.8);
		z-index: 999;
		display: flex;
		display: -webkit-flex;
		display: -moz-flex;
		align-items: center;
		-webkit-align-items: center;
		-moz-align-items: center;
		justify-content: center;
		-moz-justify-content: center;
		-webkit-justify-content: center;
	}

	.loader-div.loaded {
		display: none !important;
	}
</style>
